import { OnInit, ElementRef } from '@angular/core';
import { resolveThemeCssClass } from '../lib/helper/panel-settings';
import { applyRteSettings } from '../../shared/utils/rte-style-settings-utils';
var ImagePanelComponent = /** @class */ (function () {
    function ImagePanelComponent() {
    }
    Object.defineProperty(ImagePanelComponent.prototype, "hostClasses", {
        get: function () { return resolveThemeCssClass(this.data.panelSettings); },
        enumerable: true,
        configurable: true
    });
    ImagePanelComponent.prototype.ngOnInit = function () {
        this.showFullSize = this.data.showFullSize.value;
        if (!this.showFullSize)
            this.data.image.value.sources = [];
    };
    ImagePanelComponent.prototype.ngAfterViewInit = function () {
        applyRteSettings(this.data, this.descriptionEl);
    };
    return ImagePanelComponent;
}());
export { ImagePanelComponent };
